import { FC } from 'react';

import classes from './Content.module.scss';

import Ring from '../../assets/ring.png';

const Content: FC = () => {
  return (
    <>
      <div className={classes.message}>
        <img className={classes.ring} src={Ring} alt="ring" />
        <p>
          저희 두 사람, 손 꼭 잡고
          <br />
          하나가 되고자 합니다.
          <br />
          서로 사랑하며 배우고 성장하겠습니다.
          <br />그 시작의 기쁨을 여러분과 함께 하고싶습니다.
        </p>
      </div>
      <div className={classes.family}>
        <div className={classes.info}>
          <h3>일시</h3>
          <p className={classes.space}>2023. 03. 18.(토) 11:30</p>
          <h3>장소</h3>
          <p>아펠가모 공덕 마리에 홀</p>
        </div>
        <div className={`${classes.group} ${classes.addLine}`}>
          <p>
            한기욱&nbsp;&nbsp;&nbsp;&nbsp;강시연<span>의 아들</span>
          </p>
          <p>도형</p>
        </div>
        <div className={classes.group}>
          <p>
            심재은&nbsp;&nbsp;&nbsp;&nbsp;오세희<span>의 딸</span>
          </p>
          <p>명보</p>
        </div>
      </div>
    </>
  );
};

export default Content;
